import React from 'react';

import './styles.scss';

export const Footer: React.FC = () => (
    <footer className="footer color-2">
        <div className="footer__container">
            <div className="footer__contacts">
                <div className="footer__item">
                    <div className="footer__label">Телефон</div>
                    <a className="footer__value" href="tel:+77071059771">+7 707 105 97 71</a>
                </div>

                <div className="footer__item">
                    <div className="footer__label">Почта</div>
                    <a className="footer__value" href="mailto:info@sharesoft.kz">info@sharesoft.kz</a>
                </div>

                <div className="footer__item footer__item--wide">
                    <div className="footer__label">Адрес</div>
                    <div className="footer__value footer__value--text">
                        Казахстан, город Нур-Султан, район Байконыр, улица Амангельди Иманов, дом 10/1, ВП 22, почтовый индекс 010000
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <div>2008 - {new Date().getFullYear()} SHARESOFT KZ</div>
                <div>фото <a href="http://picls.ru">Picls</a></div>
            </div>
        </div>
    </footer>
);
